import type { FC, ReactNode } from 'react';

import { cn } from '@shared/utils';

import { Checkbox } from '../checkbox';

export interface GenericCheckboxProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  label?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  descriptionClassName?: string;
  id?: string;
}

export const GenericCheckbox: FC<GenericCheckboxProps> = ({
  checked,
  defaultChecked,
  onCheckedChange,
  label,
  description,
  disabled,
  className,
  labelClassName,
  descriptionClassName,
  id,
}) => {
  return (
    <label className={cn('flex items-center gap-2 select-none', labelClassName)} htmlFor={id}>
      <Checkbox
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        id={id}
        className={cn('h-4 w-4', className)}
      />
      {label && <span className={cn('text-sm', disabled ? 'text-neutral-500' : 'text-white')}>{label}</span>}
      {description && <span className={cn('text-xs ml-2', descriptionClassName)}>{description}</span>}
    </label>
  );
};
